
const searchFold = {
  state: {
    isFold:false,
    clueObj:{},
  },

  mutations: {
    set_isFold: (state, isBol) => {
      state.isFold = !isBol
    },
    set_clueobj: (state, obj) => {
      state.clueObj = obj
    },
  },

  actions: {

    // sdadad
    // foldAction({ commit }) {
    //     commit('set_isFold', '')
    // }
  }
}

export default searchFold



// WEBPACK FOOTER //
// ./src/store/modules/search_fold.js